<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="row">
    <div class="col-12">
      <p>
        {{ text }}
      </p>
    </div>
  </div>
  <div class="row" *ngIf="notes && notes.length">
    <div class="col-8">
      <ng-container *ngFor="let item of notes; let i = index;">
        <div class="text-wrapper">
          <mat-checkbox [(ngModel)]="item.value" class="checkbox-insert" [checked]="selectAll" (change)="onSelect($event.checked)">
            {{ item.text }}
          </mat-checkbox>
        </div>
      </ng-container>
    </div>
    <div class="col-4">
      <div class="text-wrapper text-right">
        <mat-checkbox class="checkbox-insert" (change)="onSelectAll($event.checked)" [checked]="selectAll">
          {{ 'common.cta.selectAll' | translate }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'properties.dialog.propertyPlatformNotes.noNotesBnt' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (click)="onFormSubmit()" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->